import Loading from '@/components/Loading'
import { useAppUser } from '@/lib/auth/client'

import { CustomerLayout } from './customer/CustomerLayout'

/**
 * LayoutProvider - the single (customer) layout shell.
 *
 * Used to route between `AdminLayout`/`CustomerLayout` by URL path (goal
 * 082's `next/dynamic()` split). The admin panel was deleted from Product
 * (goal 247, admin panel sunset — replaced by the standalone admin console +
 * MCP), so there is no more `/admin` route to split on. This now always
 * renders `CustomerLayout` (statically imported — a single-branch layout
 * gains nothing from `next/dynamic()`) once a user is resolved.
 */
export function LayoutProvider(props: React.PropsWithChildren) {
  const { user } = useAppUser()

  if (!user) {
    return <Loading />
  }

  return <CustomerLayout>{props.children}</CustomerLayout>
}
